import { render, staticRenderFns } from "./ContentSave.vue?vue&type=template&id=b12bec46&"
import script from "./ContentSave.vue?vue&type=script&lang=js&"
export * from "./ContentSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports